import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import AppRoutes from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // An internal portal doesn't change under you while you're reading it.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster
            position="bottom-right"
            toastOptions={{
              // Read the theme tokens so toasts follow light/dark like everything else.
              style: {
                background: 'rgb(var(--c-surface))',
                color: 'rgb(var(--c-ink))',
                border: '1px solid rgb(var(--c-line))',
                boxShadow: '0 10px 28px -14px rgb(0 0 0 / 0.35)',
                fontSize: '14px',
              },
              success: { iconTheme: { primary: 'rgb(var(--c-ok))', secondary: 'rgb(var(--c-surface))' } },
              error: { iconTheme: { primary: 'rgb(var(--c-danger))', secondary: 'rgb(var(--c-surface))' } },
            }}
          />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
